import React, { ReactElement, useContext, useState } from 'react';
import { View } from 'react-native';

import { SizeClass, useSizeClass } from '../contexts/SizeClassContext';
import Colors from '../theming/Colors';
import { ThemeContext } from '../theming/ThemeContext';
import {
  PresentationStyle,
  dismissReactNativeModal,
} from '../utilities/NativeHelpers';
import KitModalV2 from './KitModalV2';

export const PresentationWrapper = ({
  children,
  onDismiss,
  presentationStyle,
}: {
  children: ReactElement;
  onDismiss?: () => void;
  presentationStyle?: PresentationStyle;
}): ReactElement => {
  const { colorForScheme } = useContext(ThemeContext);

  const contentBackgroundColor = colorForScheme?.({
    dark: Colors.N1000,
    light: Colors.N0,
  });

  const { sizeClass, windowHeight } = useSizeClass();

  const [kitModalVisible, setKitModalVisible] = useState(
    presentationStyle === PresentationStyle.KitModal
  );

  return presentationStyle === PresentationStyle.KitModal ? (
    <KitModalV2
      onClose={() => {
        setKitModalVisible(false);
        onDismiss?.();

        setTimeout(() => {
          dismissReactNativeModal();
        }, 300);
      }}
      isVisible={kitModalVisible}
      anchorBottom={sizeClass === SizeClass.Small}
      coverScreen={true}
      noScrollView={true}
      swipeEnabled={false}
      modalStyle={{
        backgroundColor: contentBackgroundColor,
        maxHeight: windowHeight * 0.75,
        width: sizeClass === SizeClass.Small ? '100%' : 620,
        margin: 0,
      }}
    >
      <View
        style={{
          backgroundColor: contentBackgroundColor,
          maxHeight: windowHeight * 0.75,
          width: sizeClass === SizeClass.Small ? '100%' : 620,
        }}
      >
        {children}
      </View>
    </KitModalV2>
  ) : (
    children
  );
};
